// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-container {
  width: 100%;
  max-width: 1080px;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: #43425d;
  margin-top: 4px;
  padding-bottom: 32px;
}

.form-container h1 {
  text-align: center;
  margin-bottom: 20px;
}

.form-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 20px;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}

.form-group input {
  width: 100%;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.button-container {
  display: flex;
  justify-content: center; /* Align button to the center */
}

.button-container button[type="submit"] {
  background-color: #007bff;
  color: #fff;
  padding: 10px 20px;
  font-size: 16px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.button-container button[type="submit"]:hover {
  background-color: #0056b3;
}
@media (min-width: 320px) {
  .form-row {
    grid-template-columns: repeat(1, 1fr);
  }
}
@media (min-width: 375px) {
  .form-row {
    grid-template-columns: repeat(1, 1fr);
  }
}
@media (min-width: 425px) {
  .form-row {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (min-width: 768px) {
  .form-row {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 992px) {
  .form-row {
    grid-template-columns: repeat(3, 1fr);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/edituser/style.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB,EAAE,+BAA+B;AAC1D;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF","sourcesContent":[".form-container {\n  width: 100%;\n  max-width: 1080px;\n  margin: 0 auto;\n  padding: 20px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  background-color: #43425d;\n  margin-top: 4px;\n  padding-bottom: 32px;\n}\n\n.form-container h1 {\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  grid-gap: 20px;\n}\n\n.form-group {\n  margin-bottom: 15px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 5px;\n  font-weight: bold;\n}\n\n.form-group input {\n  width: 100%;\n  padding: 10px;\n  font-size: 16px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n}\n\n.button-container {\n  display: flex;\n  justify-content: center; /* Align button to the center */\n}\n\n.button-container button[type=\"submit\"] {\n  background-color: #007bff;\n  color: #fff;\n  padding: 10px 20px;\n  font-size: 16px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.button-container button[type=\"submit\"]:hover {\n  background-color: #0056b3;\n}\n@media (min-width: 320px) {\n  .form-row {\n    grid-template-columns: repeat(1, 1fr);\n  }\n}\n@media (min-width: 375px) {\n  .form-row {\n    grid-template-columns: repeat(1, 1fr);\n  }\n}\n@media (min-width: 425px) {\n  .form-row {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n@media (min-width: 768px) {\n  .form-row {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (min-width: 992px) {\n  .form-row {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
